"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemMatchedRule = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
function ItemMatchedRule(_a) {
    var rules = _a.rules;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: "matched-rules" },
        (!rules || (rules && rules.length === 0)) && (react_1.default.createElement("div", { className: "no-rule-container" },
            react_1.default.createElement("span", null, t('itemLog:TABLE.ITEM.MATCHED_RULES.NONE')))),
        rules && rules.length > 0 && (react_1.default.createElement("div", { className: "matched-rules-count-container", "data-toggle": "tooltip", title: rules[0].name },
            react_1.default.createElement("div", { className: "more-rules-text" }, rules[0].name),
            rules.length > 1 && react_1.default.createElement("span", { className: "more-rules-block" },
                "+",
                rules.length - 1)))));
}
exports.ItemMatchedRule = ItemMatchedRule;
